import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {FerryModel, NewFerryModel, FerryDropDownModel} from "../models/ferry";
import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";

export class FerryService {
    private static basicUrl = apiUrls.dictionaries.ferries;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<FerryModel>>> {
        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<FerryModel>>(url);
    }

    public static async getFerriesForDropDown(): Promise<AxiosResponse<FerryDropDownModel[]>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/dropdown`);
    }

    public static async getFerry(id: string): Promise<AxiosResponse<FerryModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async addFerry(data: NewFerryModel): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }

    public static async modifyFerry(data: NewFerryModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }

    public static async removeFerry(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }
}
